import { useLocation, useNavigate, createSearchParams } from 'react-router-dom';
import { removeFalsyKeys } from 'shared/utils/removeFalsyKeys';

const useFilters = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const setHash = (hash: string) => {
    navigate({
      pathname: location.pathname,
      search: location.search,
      hash,
    });
  };

  const getHash = () => location.hash.replaceAll('#', '');

  //Keeping the any for now, since regression impact needs to be checked in multiple places
  const getParams = (keys: string[]) => {
    const params: any = {};
    keys?.forEach(key => {
      const value = createSearchParams(location.search).get(key);
      if (isNaN(value as any) || value === null || value === '') {
        params[key] = value;
      } else {
        params[key] = +(value || '');
      }
    });
    return params;
  };

  //Keeping the any for now, since regression impact needs to be checked in multiple places
  const setParams = (filters: any, hash?: string, replace?: boolean) => {
    const params = createSearchParams(removeFalsyKeys(filters));
    navigate(
      {
        pathname: location.pathname,
        hash: hash ?? location.hash,
        search: params.toString(),
      },
      { replace: replace }
    );
  };

  return {
    location,
    setHash,
    getHash,
    getParams,
    setParams,
  };
};

export default useFilters;
